//@vendors
const React = require('react');
const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');
import { history } from 'routes/history';
//@actions
const JointHoldersActions = require('actions/jointHoldersActions');
const formActions = require('react-redux-form').actions;
const preLoaderActions = require('actions/preLoaderActions');
const productsActions = require('actions/productsActions');
const promotionalCodeAction = require('actions/promotionalCodeAction');
//@utilities
const { errorTag } = require('utilities/uTagging');
const Storage = require('utilities/storage');
//@constants
const { PATH_ERROR_404 } = require('constants/uTagConstants/paths');
const { PUBLICA_URL, ALLOW_COOKIE } = require('constants/index');
import { BASE_PATH } from 'constants/index';
import { deleteCookie } from 'utilities/logoutHelper';

class WelcomeJointHolder extends React.Component {
    constructor(props) {
        super(props);
    }

    UNSAFE_componentWillMount() {
        if (ALLOW_COOKIE) {
            deleteCookie();
        }
    }

    componentDidMount() {
        const { actions, match, formActions, preLoaderActions, productsActions, promotionalCodeAction } = this.props;
        const token = match.params.token;

        preLoaderActions.showPreLoader();

        if (token) {
            Storage.cookies.remove('accessToken');
            Storage.cookies.remove('refreshToken');
            actions.verifytoken(token, (status, data) => {
                if (status.toLowerCase() === 'error') {
                    errorTag('', PATH_ERROR_404);
                    window.location.href = PUBLICA_URL + '/page_404';
                } else {
                    const expires = new Date(new Date().getTime() + 2 * 60 * 60 * 1000);
                    Storage.cookies.set('jointHolderInvite', btoa(window.location.href), { expires });
                    data.token = token;
                    let products = {
                        products: data.accountOwner.products,
                        invite: data.invite,
                    };
                    let promoInfo = {
                        promotionalCode: data.accountOwner.promotionalCode,
                    };

                    formActions.change('userProfile.jointHolderInviteToken', token);
                    formActions.change('userProfile.isJointHolder', true);
                    formActions.change('userProfile.jointHolderData', data);
                    formActions.change('userProfile.product', data.productCode);

                    productsActions.setProductsInfo(products);

                    products.products.forEach(product => {
                        if (product.description === 'products-valuesAccount') {
                            formActions.change('userProfile.valuesAccount', true);
                        }
                    });

                    if (promoInfo.promotionalCode) {
                        promotionalCodeAction.setPromoCode(promoInfo);
                    }
                    history.push(BASE_PATH);
                }
                preLoaderActions.hidePreLoader();
            });
        }
    }

    render() {
        return null;
    }
}

module.exports.constructor = WelcomeJointHolder;
module.exports.WelcomeJointHolder = connect(null, dispatch => ({
    actions: bindActionCreators(JointHoldersActions, dispatch),
    formActions: bindActionCreators(formActions, dispatch),
    preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
    productsActions: bindActionCreators(productsActions, dispatch),
    promotionalCodeAction: bindActionCreators(promotionalCodeAction, dispatch),
}))(WelcomeJointHolder);
